export var supportedCurrencyInfo = [{
  currencySymbol: '$',
  currencyCode: 'AUD',
  currencyFormat: 'AUD ${amount}',
  locale: 'en-AU'
}, {
  currencySymbol: '€',
  currencyCode: 'EUR',
  currencyFormat: '€{amount}',
  locale: 'en-EU'
}, {
  currencySymbol: '£',
  currencyCode: 'GBP',
  currencyFormat: '£{amount}',
  locale: 'en-GB'
}, {
  currencySymbol: '$',
  currencyCode: 'USD',
  currencyFormat: '${amount}',
  locale: 'en-US'
}, {
  currencySymbol: '$',
  currencyCode: 'HKD',
  currencyFormat: 'HK${amount}',
  locale: 'en-HK'
}, {
  currencySymbol: '$',
  currencyCode: 'CAD',
  currencyFormat: 'CAD ${amount}',
  locale: 'en-CA'
}, {
  currencySymbol: '₹',
  currencyCode: 'INR',
  currencyFormat: '₹{amount}',
  locale: 'en-IN'
}, {
  currencySymbol: 'Rp',
  currencyCode: 'IDR',
  currencyFormat: 'Rp {amount}',
  doNotShowDecimalPlaces: true,
  locale: 'id-ID'
}, {
  currencySymbol: '₩',
  currencyCode: 'KRW',
  currencyFormat: '₩{amount}',
  doNotShowDecimalPlaces: true,
  locale: 'ko-KR'
}, {
  currencySymbol: 'RM',
  currencyCode: 'MYR',
  currencyFormat: 'RM {amount}',
  locale: 'en-MY'
}, {
  currencySymbol: '$',
  currencyCode: 'MXN',
  currencyFormat: '${amount} MXN',
  locale: 'es-MX'
}, {
  currencySymbol: '₱',
  currencyCode: 'PHP',
  currencyFormat: '₱{amount}',
  locale: 'en-PH'
}, {
  currencySymbol: 'ر.س',
  currencyCode: 'SAR',
  currencyFormat: 'SAR {amount}',
  locale: 'en-SA'
}, {
  currencySymbol: '$',
  currencyCode: 'SGD',
  currencyFormat: 'S${amount}',
  locale: 'en-SG'
}, {
  currencySymbol: 'R',
  currencyCode: 'ZAR',
  currencyFormat: 'R {amount}',
  locale: 'en-ZA'
}, {
  currencySymbol: '₺',
  currencyCode: 'TRY',
  currencyFormat: '₺{amount}',
  locale: 'tr-TR'
}, {
  currencySymbol: 'د.إ',
  currencyCode: 'AED',
  currencyFormat: 'AED {amount}',
  locale: 'en-AE'
}];


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/currencyFormatter/constants.js
// module id = 4070
// module chunks = 11